export default __webpack_public_path__ + "static/media/2020.0a954586.png";